import { throttle } from 'lodash-es';
// add scroll end event listener for a dom element with pollyfill for safari
export function onScrollEnd(domElement, callback, eventOptions = {}) {
    const { once = false, polyfillDelay = 100 } = eventOptions;
    let scrollEndTimer;
    const polyfillScrollCallback = () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(() => {
            if (once) {
                domElement.removeEventListener('scroll', polyfillScrollCallback);
            }
            callback();
        }, polyfillDelay);
    };
    if ('onscrollend' in window) {
        domElement.addEventListener('scrollend', callback, { once });
    }
    else {
        domElement.addEventListener('scroll', polyfillScrollCallback);
    }
    return () => {
        if ('onscrollend' in window) {
            domElement.removeEventListener('scrollend', callback);
        }
        else {
            domElement.removeEventListener('scroll', polyfillScrollCallback);
        }
    };
}
/**
 * Creates a batched updater that collects payloads and calls the callback with all collected payloads after a delay.
 * Useful for batching frequent updates to reduce the number of state updates.
 */
export function createBatchedUpdater(callback, delay = 1000) {
    const payloads = [];
    const throttledCallback = throttle(() => {
        if (payloads.length > 0) {
            callback([...payloads]);
            payloads.length = 0;
        }
    }, delay);
    const batchFunc = (payload) => {
        payloads.push(payload);
        throttledCallback();
    };
    batchFunc.flush = () => {
        throttledCallback.flush();
    };
    return batchFunc;
}
